import { IUserTicketData } from 'meta/pages/v4/ticket'

export type TicketState = {
  tickets: Record<string, IUserTicketData>
}

export const initialState: TicketState = {
  tickets: {},
}
